export const VerificaDocumentiCaricatiFilterComponent = {
    template: require('./verifica-documenti-caricati-filter.html'),
    controller: class VerificaDocumentiCaricatiFilterComponent {

        private filterTemp: any;

        private resolve: any;
        private close: any;
        private dismiss: any;

        private settings: any;

        $onInit(): void {
            this.settings = this.resolve.filter;
            this.filterTemp = JSON.parse(JSON.stringify(this.settings.filter));
        }

        clearFilter() {
            this.filterTemp.fileName = '';
            this.filterTemp.dataDocumentoFrom = '';
            this.filterTemp.dataDocumentoTo = '';
            this.filterTemp.denominazione = '';
            this.filterTemp.partitaIva = '';
            this.filterTemp.codiceFiscale = '';
            this.filterTemp.tipoDocumento = '';
            this.filterTemp.numeroDocumento = '';
            this.filterTemp.sender = '';
            this.filterTemp.primaryRecipient = '';
            this.filterTemp.subject = '';
            this.filterTemp.receipt = '';
            this.filterTemp.completeStatus = '';
            this.filterTemp.periodo = '';
            this.filterTemp.pageNumber = 1;
        }

        updateDateField(field: string, value: Date) {
            this.filterTemp[field] = value;
        }

        save() {
            this.settings.filter = this.filterTemp;
            this.settings.filter.pageNumber = 1;
            this.close({ $value: this.settings });
        }

        cancel() {
            this.dismiss();
        }
    },
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/verifica-documenti-caricati-filter/verifica-documenti-caricati-filter.ts